/*
 * Copyright (c) Dito Technologies
 */

import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import React from "react"
import {
    NoteFinderPageOverlayNoteBulb_Bulb$data
} from "ui/feature/root/note-select/__generated__/NoteFinderPageOverlayNoteBulb_Bulb.graphql";
import styles from "./NoteFinderPageOverlayNoteBulb.module.scss"

interface Props {
    noteWidth: number;
    noteHeight: number;
    noteX: number;
    noteY: number;
    bulb: NoteFinderPageOverlayNoteBulb_Bulb$data
}

const NoteFinderPageOverlayNoteBulb: React.FC<Props> = ({noteHeight, noteWidth, bulb, noteX, noteY}) => {

    const width = React.useMemo(() => {
        return `${(bulb.width / noteWidth) * 100}%`;
    }, [bulb.width, noteWidth])

    const height = React.useMemo(() => {
        return `${(bulb.height / noteHeight) * 100}%`;
    }, [bulb.height, noteHeight]);

    const left = React.useMemo(() => {
        return `${(bulb.x / noteWidth) * 100}%`;
    }, [bulb.x, noteWidth]);

    const top = React.useMemo(() => {
        return `${(bulb.y / noteHeight) * 100}%`;
    }, [bulb.y, noteHeight])

    const linePoints = React.useMemo(() => {
        // TODO: Use an SVG for the real deal.
        const output = []
        const startX = bulb.x + noteX;
        const endX = bulb.x + bulb.width + noteX;
        let mainLineNumber = 0;
        for (const mainLine of bulb.main_lines) {
            mainLineNumber += 1;
            const formula = (x: number) => {
                return (mainLine.a * x) + mainLine.b;
            }
            let currX = startX;
            while (currX < endX) {
                const currY = formula(currX);
                const adjustedX = currX - noteX;
                const adjustedY = currY - noteY;
                const xPercent = `${(adjustedX / noteWidth) * 100}%`;
                const yPercent = `${(adjustedY / noteHeight) * 100}%`;
                output.push(
                    <div
                        key={`${bulb.bulb_id}-${mainLineNumber}-${currX}`}
                        className={styles.bulbLinePoint}
                        style={{
                            left: xPercent,
                            top: yPercent
                        }}
                    />
                )
                currX += 5;
            }
        }
        return output
    }, [bulb.bulb_id, bulb.main_lines, bulb.width, bulb.x, noteHeight, noteWidth, noteX, noteY])

    return (
        <>
            <div
                className={bulb.has_dot ? styles.bulbDot : styles.bulb}
                style={{
                    width: width,
                    height: height,
                    left: left,
                    top: top
                }}
            />
            {linePoints}
        </>
    )
}

export default createFragmentContainer(NoteFinderPageOverlayNoteBulb, {
    bulb: graphql`
    fragment NoteFinderPageOverlayNoteBulb_Bulb on MusicParseStepDataNoteDataSourceCombineNoteBulb {
        bulb_id
        x
        y
        width
        height
        confidence
        has_dot
        main_lines {
            a
            b
        }
    }
    `
});